<header>
  <div *ngIf="isPolicyPage() || isConfirmationPage(); else normalHeader" class="container header-inner">
    <div style="display: flex; align-items: center; padding: 0;">
        <a routerLink="/" title="Juno Audit"><img class="header__logo" alt="Juno Audit ? powered by AI" width="144" height="130" src="images/juno-audit-landing-logo-gradient.png" style="margin: 0;" /></a>
      </div>
    <div class="header-actions">
      <span *ngIf="showEnvironmentBadge" class="environment-badge">{{ environmentName }}</span>
      <a routerLink="/login" class="header-login">
        <i class="fa-solid fa-right-to-bracket"></i> Przejdź do Juno
      </a>
      <a routerLink="/" class="header-back" >
        <i class="fa-solid fa-arrow-left"></i> Powrót do strony głównej
      </a>
    </div>
  </div>

  <ng-template #normalHeader>
    <div class="container header-inner">
      <div style="display: flex; align-items: center; padding: 0;">
        <a routerLink="/" title="Juno Audit"><img class="header__logo" alt="Juno Audit ? powered by AI" width="144" height="130" src="images/juno-audit-landing-logo-gradient.png" style="margin: 0;" /></a>
      </div>

      <div class="header-actions">
        <span *ngIf="showEnvironmentBadge" class="environment-badge">{{ environmentName }}</span>
      </div>

      <nav>
        <a href="#" (click)="scrollTo('juno', $event)">Jak to działa</a>
        <a href="#" (click)="scrollTo('benefits', $event)">Funkcje platformy</a>
        <a href="#" (click)="scrollTo('partners', $event)">Dla kogo</a>
        <a href="#" (click)="scrollTo('example', $event)">Zalety Juno Audit</a>

        <!--
      <div class="lang-switch">
        <button (click)="toggleLang()">
          <i class="fas fa-globe"></i>
          <span>{{ currentLang.toUpperCase() }}</span>
        </button>
        <ul class="lang-menu" *ngIf="langOpen">
          <li (click)="setLang('pl')">Polski</li>
          <li (click)="setLang('en')">English</li>
        </ul>
      </div>-->
      </nav>

      <div class="header-actions header-actions--right">
        <button class="header-cta" (click)="scrollTo('JoinUs', $event)">
          <i class="fa-solid fa-user-plus"></i> Dołącz do Juno Audit
        </button>
        <a routerLink="/login" class="header-login">
          <i class="fa-solid fa-right-to-bracket"></i> Przejdź do Juno
        </a>
      </div>

      <!-- Hamburger + Mobile nav -->
      <button class="hamburger" (click)="toggleMobileNav()">
        <i class="fas fa-bars"></i>
      </button>
      <!-- mobile menu, klasa 'show' dodawana gdy otwarte -->
      <div class="mobile-nav" [class.show]="mobileNavOpen">
        <span *ngIf="showEnvironmentBadge" class="environment-badge mobile-environment">{{ environmentName }}</span>
        <a routerLink="/login" (click)="mobileNavOpen = false">
          <i class="fa-solid fa-right-to-bracket"></i> Przejdź do Juno
        </a>
        <a href="#" (click)="scrollTo('juno', $event)">Jak to działa</a>
        <a href="#" (click)="scrollTo('benefits', $event)">Funkcje platformy</a>
        <a href="#" (click)="scrollTo('partners', $event)">Dla kogo</a>
        <a href="#" (click)="scrollTo('example', $event)">Zalety Juno Audit</a>
        <!-- 
      <div class="lang-switch mobile-lang">
        <button (click)="toggleLang()">
          <i class="fas fa-globe"></i>
          <span>{{ currentLang.toUpperCase() }}</span>
        </button>
        <ul class="lang-menu" *ngIf="langOpen">
          <li (click)="setLang('pl')">Polski</li>
          <li (click)="setLang('en')">English</li>
        </ul>
      </div>-->
      </div>

    </div>
  </ng-template>
</header>
